/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MessageIcon.vue?vue&type=template&id=7776377a"
import script from "./MessageIcon.vue?vue&type=script&lang=js"
export * from "./MessageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7776377a')) {
      api.createRecord('7776377a', component.options)
    } else {
      api.reload('7776377a', component.options)
    }
    module.hot.accept("./MessageIcon.vue?vue&type=template&id=7776377a", function () {
      api.rerender('7776377a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/MessageIcon.vue"
export default component.exports